import { crudGetters } from "@/utils/store.js";
import isEmpty from "lodash/isEmpty.js";

const BASE_URL = process.env.BASE_URL_V2

export const state = () => ({
  objects: [],
  total: 0,
  materialCategories: [],
  mainArts: [],
  mainArtsTotal: 0,
})

export const mutations = {
  SET_OBJECTS(state, payload) {
    state.objects = payload.objects.map(x => {
      x.key = x.idx
      return x
    });
    state.total = payload.total;
  },
  SET_CATEGORIES(state, categories) {
    state.materialCategories = categories
  },
  SET_MAIN_ARTS(state, payload) {
    state.mainArts = payload
  },
  SET_MAIN_ARTS_TOTAL(state, total) {
    state.mainArtsTotal = total
  },
}

const processItems = (items) => {
  return items.map(item => {
    item.has_image = true

    try {
      item.cover = item.blocks[0].image.image_450_file
    } catch (e) {
    }

    if (item.sublabel) {
      item.text = item.sublabel
    } else {
      try {
        item.text = item.blocks[1].text
      } catch (e) {

      }
    }

    return item
  })
}

export const actions = {
  fetchMaterialsForObject(context, id) {
    return this.$axios.$get(`${BASE_URL}/public/materials/for_object/${id}/`)
      .then((articles) => processItems(articles.items))
  },
  fetchMaterialCategories({ commit }) {
    return this.$axios.$get(`${BASE_URL}/public/materials/categories_ranged/`)
      .then((res) => commit('SET_CATEGORIES', res.items))
  },
  async edit({}, payload) {
    return this.$axios.$post(`${BASE_URL}/admin/material_edit/`, payload)
  },
  async getAdminObject({}, id) {
    return this.$axios.$get(`${BASE_URL}/admin/material_edit/${id}/`)
  },
  async getAdminObjects({ commit }, params = {}) {
    const response = await this.$axios.$get(`${BASE_URL}/admin/materials/`, { params: params })
    commit('SET_OBJECTS', { objects: processItems(response['items']), total: response['total'] })
    return response
  },
  async publicObject({}, id) {
    return this.$axios.$get(`${BASE_URL}/public/materials/${id}/`)
  },
  async publicObjectComments({}, { id, params }) {
    return this.$axios.$get(`${BASE_URL}/public/comments/?obj_cls=materials&obj_id=${id}`,
      { params: params })
      .then(response => {
        return response.items
      })
  },
  async publicUserComments({}, { id, params }) {
    return this.$axios.$get(`${BASE_URL}/public/comments/user_comments_list/?user_id=${id}`,
      { params: params })
      .then(response => {
        return response.items
      })
  },
  async publicObjects({}, params) {
    return this.$axios.$get(`${BASE_URL}/public/materials/`,
      { params: { is_about_project: false, ...params } })
      .then(response => {
        response.items = processItems(response.items)

        return response
      })
  },
  async publicMaterialsSearch({ dispatch }, params) {
    const { skipEnrich, ...searchParams } = params
    const response = await this.$axios.$get(`${BASE_URL}/public/materials/search/`, { params: searchParams })

    if (skipEnrich || !response.items?.length) {
      return response
    }

    const ids = response.items.map(item => item.id).join(',')
    const { items: fullItems } = await dispatch('publicObjects', {
      ids,
      limit: response.items.length,
      is_about_project: null,
    })

    const itemsById = Object.fromEntries(fullItems.map(item => [item.id, item]))
    response.items = response.items
      .map(item => itemsById[item.id])
      .filter(Boolean)

    return response
  },
  async publicObjectsByAuthor({}, params = {}) {
    const { user, user_id, ...rest } = params
    const authorId = user ?? user_id
    return this.$axios.$get(`${BASE_URL}/public/materials/`, {
      params: {
        is_about_project: false,
        is_published: 1,
        ...(authorId ? { user: authorId } : {}),
        ...rest,
      },
    }).then((response) => {
      response.items = processItems(response.items)
      return response
    })
  },
  asideObjects({}, { id, params }) {
    return this.$axios.$get(`${BASE_URL}/public/materials/${id}/object_right_sidebar/`,
      { params: params })
      .then(response => {
        return processItems(response.items)
      })
  },
  myOwnerObjects({}, params) {
    return this.$axios.$get(
      `${BASE_URL}/public/materials/my/`,
      { params: params })
      .then(response => {
        response.items = processItems(response.items)

        return response
      })
  },
  registerView({}, slug) {
    return this.$axios.$post(`${BASE_URL}/public/materials/register_view/${slug}/`, {
      referer: document.referrer
    })
  },
  deleteObject({}, id) {
    return this.$axios.$delete(`${BASE_URL}/admin/materials/${id}/`)
  },
  async getMainArts({ state, commit, dispatch }, params) {
    const objects = await dispatch('publicObjects', {
      ...params,
      limit: params?.limit ?? 12,
      offset: params?.offset ?? 0,
      order: params?.order ?? '-total_score',
    })

    if (typeof objects.total === 'number') {
      commit('SET_MAIN_ARTS_TOTAL', objects.total)
    }

    if (params?.offset && params?.offset > 0) {
      commit('SET_MAIN_ARTS', [...state.mainArts, ...objects.items])
    } else {
      commit('SET_MAIN_ARTS', objects.items)
    }

    return objects
  },
}

export const getters = {
  ...crudGetters,
  getMainArts: (state) => state.mainArts,
  getMainArtsTotal: (state) => state.mainArtsTotal,
}
